import NextLink from "next/link";
import PropTypes from "prop-types";
import {
  Box,
  Card,
  CardHeader,
  Divider,
  IconButton,
  Link,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
  Tooltip,
  CardContent,
  Button,
} from "@mui/material";
import { Scrollbar } from "../../scrollbar";
import ContactPhoneIcon from "@mui/icons-material/ContactPhone";
import { exportarLeadsExcel } from "../../../utils/exportarLedasCallCenter";

export const CallCenterContactosListResumen = (props) => {
  const { contactos = [], user } = props;



  const generarExcel = async () => {
    // Realiza una peticion GET a la API al endpoint /api/v1/generators/reporteCallCenterLeads
    // Este endpoint retorna un buffer con el archivo de excel
    const res = await fetch("/api/v1/generators/reporteCallCenterLeads");
    const blob = await res.blob();

    // Crea un objeto URL para el blob
    const url = window.URL.createObjectURL(blob);

    // Crea un elemento <a> para descargar el archivo
    const a = document.createElement("a");
    a.href = url;
    a.download = "reporte-call-center-leads.xlsx";
    a.click();

    // Limpia la URL creada
    URL.revokeObjectURL(url);
  };

  return (
    <>
      {(contactos.length > 0 && (
        <Card>
          <CardHeader title="Contactos" />
          <Divider />
          <Scrollbar>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexDirection: "row",
              }}
            >
              <Typography
                color="textSecondary"
                variant="subtitle2"
                sx={{ m: 2 }}
              >
                Mostrando los ultimos {contactos.length} contactos
              </Typography>
              {user.role === "callcenteradmin" && (
                <Button
                  color="primary"
                  variant="contained"
                  sx={{ m: 2 }}
                  onClick={generarExcel}
                >
                  Descargar historial de contactos
                </Button>
              )}
            </Box>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Nombre</TableCell>
                  <TableCell>Fecha</TableCell>
                  <TableCell>Telefono</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {contactos.map((contacto) => {
                  return (
                    <TableRow hover key={contacto?.id}>
                      <TableCell>
                        <NextLink
                          href={"/dashboard/contactos/" + contacto?.id}
                          passHref
                        >
                          <Link color="inherit" variant="subtitle2">
                            {contacto?.name
                              ? contacto?.name + " " + contacto?.surname
                              : "N/D"}
                          </Link>
                        </NextLink>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2">
                          {contacto?.createdAt
                            ? new Date(
                                contacto?.createdAt._seconds * 1000
                              ).toLocaleDateString()
                            : "N/D"}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Typography variant="subtitle2">
                          {contacto?.phone ? contacto?.phone : "N/D"}
                        </Typography>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </Scrollbar>
        </Card>
      )) || (
        <Card
          sx={{
            height: "100%",
          }}
        >
          <CardContent
            sx={{
              alignItems: "center",
              display: "flex",
              flexDirection: "column",
              p: 4,
            }}
          >
            <ContactPhoneIcon
              sx={{
                color: "success.main",
                height: 56,
                width: 56,
              }}
            />
            <Typography color="textSecondary" variant="h5" sx={{ mt: 2 }}>
              No hay contactos nuevos
            </Typography>
            <Typography color="textSecondary" variant="subtitle2">
              No se han registrado nuevos contactos en los ultimos 30 días
            </Typography>
          </CardContent>
        </Card>
      )}
    </>
  );
};

CallCenterContactosListResumen.propTypes = {
  contactos: PropTypes.array.isRequired,
  oportunidadesCount: PropTypes.number.isRequired,
};
